<mat-toolbar *ngIf="!dialogRef.disableClose">
  <span class="register-login-spacer"></span>
  <button mat-icon-button mat-dialog-close class="close-button">
    <mat-icon>close</mat-icon>
  </button>
</mat-toolbar>
<mat-dialog-content class="auth-dialog-content">
  <div class="grid-layout dialog-content">
    <div class="login-options">
      <app-register *ngIf="type === 'register'"></app-register>
      <app-login *ngIf="type === 'login'"></app-login>
      <app-verify *ngIf="type === 'verify'"></app-verify>
      <app-reset-password *ngIf="type === 'reset-password'"></app-reset-password>
    </div>
  </div>
</mat-dialog-content>
